module.exports = __webpack_public_path__ + "media/application/images/ui/nav-group-arrow-3bb4967722cd1c3b8723323483d566ff.svg";